import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DecimalInputField from 'components/layout/forms/DecimalInputField';
import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';

const AddConnectionByWallLine = ({
  actionTriggeredCallback,
}: {
  actionTriggeredCallback: () => void;
}): JSX.Element | null => {
  const [distance, setDistance] = useState(1000);
  const { t } = useTranslation([translations.common]);

  const addConnection = () => {
    window.AddConnection({ distance });
    actionTriggeredCallback();
  };

  const onDistanceChange = (e: any) => {
    setDistance(e.target.value);
  };

  return (
    <>
      <DecimalInputField
        id="distance"
        label={t(`${translations.common}:Distance from start`)}
        onChange={onDistanceChange}
        value={distance}
        name="distance"
        required
      />

      <PrimaryButton onClick={addConnection}>
        {t(`${translations.common}:Add`).toLocaleUpperCase()}
      </PrimaryButton>
    </>
  );
};

export default AddConnectionByWallLine;
